import React, { useState, useEffect } from 'react';
import { getAuthToken, isAuthenticated } from '@/services/auth';

const DebugInfo: React.FC = () => {
  const [debugInfo, setDebugInfo] = useState<any>({});

  useEffect(() => {
    const updateDebugInfo = () => {
      setDebugInfo({
        isAuthenticated: isAuthenticated(),
        token: getAuthToken() ? 'Presente' : 'No encontrado',
        apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'https://api.centroautomotrizhlfrd.com.do/api',
        timestamp: new Date().toLocaleTimeString()
      });
    };

    updateDebugInfo();
    const interval = setInterval(updateDebugInfo, 5000);

    return () => clearInterval(interval);
  }, []);

  // Solo mostrar en desarrollo
  if (import.meta.env.PROD) return null;

  return (
    <div className="fixed bottom-4 left-4 bg-gray-800 text-white p-3 rounded-lg text-xs max-w-xs z-50">
      <h4 className="font-bold mb-2">🐛 Debug Info</h4>
      <div className="space-y-1">
        <div>Auth: {debugInfo.isAuthenticated ? '✅' : '❌'}</div>
        <div>Token: {debugInfo.token}</div>
        <div>API: {debugInfo.apiBaseUrl}</div>
        <div>Time: {debugInfo.timestamp}</div>
      </div>
    </div>
  );
};

export default DebugInfo;
